import { Injectable } from "@angular/core";
import { AsyncSubject, BehaviorSubject, Observable } from "rxjs";
import { HubUser } from "@appcore/models/user";

/**
 * An abstract authentication service custom overlay for the okta validation api.
 *
 * @author    John Ying <john.ying@childrenshospitals.org>
 * @created   8/31/2023
 */
@Injectable()
export abstract class AuthenticationService {
	//OktaAuthService callback values
	static currentUserSubject: AsyncSubject<HubUser> = new AsyncSubject();
	static redirectUrl?: string;

	currentUser: Observable<any>;
	adminRoleLevel: number;
	$authed: BehaviorSubject<boolean>;

	abstract login(params?: any): void;
	abstract logout(): any;
	abstract isAuthenticated(): Promise<boolean>;
	abstract currentUserValue(): any;
	abstract getCurrentUserValue(): any;
}
